module.exports = __webpack_public_path__ + "static/yahoofinance-ad9cf4b93a37b6380c9306b4078635da.png";